module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-regular.c03588a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-regular.ttf
// module id = 481
// module chunks = 0